import Vue from "vue";
import Vuex from "vuex";
import store from "./store";
import router from "./router/index";
import App from "./App";
import "reset-css";

import "../static/assets/css/style.css";
import "@/assets/css/formulate.css";
import common from "./common";
import Meta from "vue-meta";

import { initSentry } from "@/helpers/sentry";
import { axiosInterceptor } from "@/helpers/axios";
import hotjar from "@/helpers/hotjar";
import GA from "@/helpers/GA";
import GTM from "@/helpers/gtm";
import channelTalk from "./helpers/channelTalk";
import mixins from "@/helpers/mixins";
import vueNaver from "vue-naver-maps";
import { version } from "@/helpers/version";
import "@/helpers/directive.js";
import "@/helpers/filter";
import VueFormulate from "@braid/vue-formulate";
import * as validation from "@/helpers/validation.js";
import ToggablePassword from "@/components/common/CustomInput/ToggablePassword";
import NumberInput from "@/components/common/CustomInput/NumberInput";
import NumberPassword from "@/components/common/CustomInput/NumberPassword";
import { initMixpanel } from "@/helpers/mixpanel";

Vue.config.productionTip = false;
version();
initMixpanel();
mixins(Vue);
GA(); //google analytics
Vue.use(common);
Vue.use(Vuex);
Vue.use(Meta);
Vue.use(GTM);
Vue.use(vueNaver, {
  clientID: "bo5j7osm10"
});
Vue.component("ToggablePassword", ToggablePassword);
Vue.component("NumberInput", NumberInput);
Vue.component("NumberPassword", NumberPassword);
Vue.use(VueFormulate, {
  locales: {
    en: validation.validationMsg
  },
  rules: validation.validationRules,
  library: {
    "toggable-password": {
      classification: "text",
      component: "ToggablePassword"
    },
    "number-input": {
      classification: "text",
      component: "NumberInput"
    },
    "number-password": {
      classification: "text",
      component: "NumberPassword"
    }
  }
});

axiosInterceptor();
store.dispatch("initializeStore");

hotjar();

channelTalk.loadScript();
channelTalk.boot();

initSentry(Vue, router);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#wrapper");
